import { Box, BoxProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export const AbsoluteOverlay = ({
  children,
  ...props
}: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      w="full"
      h="full"
      bgColor="rgba(0, 0, 0, 0.5)" // Semi-transparent black overlay
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="md"
      {...props}
    >
      {children}
    </Box>
  );
};
